export default __webpack_public_path__ + "static/media/tgif.25b807ce.png";